<template>
  <div class="More">

    <!-- Masthead -->
    <SurveyMasthead
      title="More Projects"
      subtitle="A Brief Sample of Past Projects."
      srcImage="/assets/digital/other/mast-icon-other-330.png"
      largeImage="/assets/digital/other/mast-icon-other-660.png"
      :srcSize="330"
      bgColour="#00A2CB" />


    <!-- Project Details -->
    <div class="details">

      <!-- MacComm -->
      <ContentSection title="Macdonald Commercial" :centered="true">
        <p>I designed and oversaw the build of their commercial sales &amp; lease listings website, rental listings website and their property management portal.</p>

        <ProjectImageLaptop
          srcImage="/assets/digital/other/maccomm-690.jpg"
          largeImage="/assets/digital/other/maccomm-1800.jpg"
          :canZoom="true" />


        <ProjectImageMobile
          srcImage1="/assets/digital/other/maccomm-search-330.png"
          largeImage1="/assets/digital/other/maccomm-search-660.png"
          srcImage2="/assets/digital/other/maccomm-listing-330.png"
          largeImage2="/assets/digital/other/maccomm-listing-660.png"
          :showTab="false" />
      </ContentSection> 


      <!-- Cadex -->
      <ContentSection title="Cadex Electronics" :centered="true">
        <p>I designed and oversaw the build of their marketing &amp; multi-currency ecommerce website.</p>

        <ProjectImageLaptop
          srcImage="/assets/digital/other/cadex-690.jpg"
          largeImage="/assets/digital/other/cadex-1800.jpg"
          :canZoom="true" />


        <ProjectImageMobile
          srcImage1="/assets/digital/other/cadex-home-330.jpg"
          largeImage1="/assets/digital/other/cadex-home-660.jpg"
          srcImage2="/assets/digital/other/cadex-product-330.jpg"
          largeImage2="/assets/digital/other/cadex-product-660.jpg"
          :canScroll2="true"
          :showTab="false" />
      </ContentSection> 


      <!-- Other -->
      <ContentSection title="Other Projects" :centered="true">
        <p>A sample of older projects where I produced the design, strategy and oversaw the build.</p>

        <ProjectImageLaptop
          srcImage="/assets/digital/other/w-hollywood-690.jpg"
          largeImage="/assets/digital/other/w-hollywood-1800.jpg"
          :canScroll="false"
          :canZoom="true" />

        <ProjectImageLaptop
          srcImage="/assets/digital/other/hk-690.jpg"
          largeImage="/assets/digital/other/hk-1800.jpg"
          :canScroll="false"
          :canZoom="true" />

        <ProjectImageLaptop
          srcImage="/assets/digital/other/sipology-690.png"
          largeImage="/assets/digital/other/sipology-1800.png"
          :canScroll="false"
          :canZoom="true" />

        <ProjectImageLaptop
          srcImage="/assets/digital/other/tower-690.jpg"
          largeImage="/assets/digital/other/tower-1800.jpg"
          :canScroll="false"
          :canZoom="true" />

      </ContentSection>    

    </div>

    <Pagination
      prevLabel="Epicure"
      nextLabel="Hyatt"
      prevRoute="Epicure"
      nextRoute="Hyatt" />

    <Footer />
  </div>
</template>

<script>
import SurveyMasthead from '@/components/SurveyMasthead.vue'
import Footer from '@/components/Footer.vue'
import Pagination from '@/components/Pagination.vue'
import ContentSection from '@/components/ContentSection.vue'
import ProjectImageMobile from '@/components/ProjectImageMobile.vue'
import ProjectImageLaptop from '@/components/ProjectImageLaptop.vue'

export default {
  name: 'More',
  components: {
    SurveyMasthead,
    Footer,
    Pagination,
    ContentSection,
    ProjectImageMobile,
    ProjectImageLaptop
  },
}
</script>

<style lang="scss" scoped>
  .More {
    background: #fff;
  }
</style>
